import Vue from 'vue'

// Suppress a known Firebase Analytics / web-vitals SDK bug that fires a harmless
// "Cannot read properties of undefined (reading 'startTime')" error during SPA navigation.
window.addEventListener('error', (e) => {
    if (e.message?.includes('startTime')) e.preventDefault()
})
import Toasted from 'vue-toasted'
import App from './App'
import router from '@/router'
import { store } from './store'
if (typeof window !== 'undefined') window.__store = store
import apiForDebug from '@/providers/Api'
if (typeof window !== 'undefined') window.__api = apiForDebug
import {StatusBar, Style} from '@capacitor/status-bar';

import Utils from './providers/Utils'

import {
    AlertPlugin,
    BadgePlugin,
    ButtonPlugin,
    CardPlugin,
    CollapsePlugin,
    FormCheckboxPlugin,
    FormDatepickerPlugin,
    FormFilePlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormPlugin,
    FormRadioPlugin,
    FormSelectPlugin,
    FormTextareaPlugin,
    InputGroupPlugin,
    LayoutPlugin,
    ListGroupPlugin,
    ModalPlugin,
    NavbarPlugin,
    PaginationPlugin,
    PopoverPlugin,
    ProgressPlugin,
    SidebarPlugin,
    SpinnerPlugin,
    TablePlugin,
    TabsPlugin,
    BOverlay,
    BIcon,
    BIconArchiveFill,
    BIconArrowRepeat,
    BIconArrowRightCircle,
    BIconBarChartFill,
    BIconBarChartLine,
    BIconCalendarCheck,
    BIconCardChecklist,
    BIconCaretDown,
    BIconCaretDownFill,
    BIconCaretUpFill,
    BIconCheck,
    BIconCheckCircle,
    BIconCheckCircleFill,
    BIconChevronDown,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronRight,
    BIconCloudArrowUpFill,
    BIconDownload,
    BIconEnvelope,
    BIconEnvelopeFill,
    BIconExclamationOctagonFill,
    BIconEyeFill,
    BIconEyeglasses,
    BIconFileEarmarkCheck,
    BIconGraphUp,
    BIconHouseDoorFill,
    BIconHouseFill,
    BIconInfoCircleFill,
    BIconLink,
    BIconLink45deg,
    BIconPencil,
    BIconPencilFill,
    BIconPersonCircle,
    BIconPersonFill,
    BIconPersonXFill,
    BIconPlusCircleFill,
    BIconPrinter,
    BIconQuestionCircleFill,
    BIconTrashFill,
    BIconX,
    BIconXCircle,
    BIconXCircleFill,
    BIconXLg,
    BIconXSquareFill,
} from 'bootstrap-vue'

import api from '@/providers/Api'
import i18n from '@/providers/i18n'
import VueMq from 'vue-mq'
import {Capacitor} from "@capacitor/core";
import { ScreenOrientation } from "@capacitor/screen-orientation";

Vue.use(Toasted, { duration: 5000, containerClass: 'sr-toast-container' })

Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(SidebarPlugin)
Vue.use(ButtonPlugin)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(SpinnerPlugin)
Vue.use(FormPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormFilePlugin)
Vue.use(CollapsePlugin)
Vue.use(CardPlugin)
Vue.use(PopoverPlugin)
Vue.use(TabsPlugin)
Vue.use(AlertPlugin)
Vue.use(BadgePlugin)
Vue.use(ModalPlugin)
Vue.use(ListGroupPlugin)
Vue.use(ProgressPlugin)

Vue.config.productionTip = false

Vue.component('b-overlay', BOverlay)
Vue.component('BIcon', BIcon)
Vue.component('BIconArchiveFill', BIconArchiveFill)
Vue.component('BIconArrowRepeat', BIconArrowRepeat)
Vue.component('BIconArrowRightCircle', BIconArrowRightCircle)
Vue.component('BIconBarChartFill', BIconBarChartFill)
Vue.component('BIconBarChartLine', BIconBarChartLine)
Vue.component('BIconCalendarCheck', BIconCalendarCheck)
Vue.component('BIconCardChecklist', BIconCardChecklist)
Vue.component('BIconCaretDown', BIconCaretDown)
Vue.component('BIconCaretDownFill', BIconCaretDownFill)
Vue.component('BIconCaretUpFill', BIconCaretUpFill)
Vue.component('BIconCheck', BIconCheck)
Vue.component('BIconCheckCircle', BIconCheckCircle)
Vue.component('BIconCheckCircleFill', BIconCheckCircleFill)
Vue.component('BIconChevronDown', BIconChevronDown)
Vue.component('BIconChevronDoubleLeft', BIconChevronDoubleLeft)
Vue.component('BIconChevronDoubleRight', BIconChevronDoubleRight)
Vue.component('BIconChevronRight', BIconChevronRight)
Vue.component('BIconCloudArrowUpFill', BIconCloudArrowUpFill)
Vue.component('BIconDownload', BIconDownload)
Vue.component('BIconEnvelope', BIconEnvelope)
Vue.component('BIconEnvelopeFill', BIconEnvelopeFill)
Vue.component('BIconExclamationOctagonFill', BIconExclamationOctagonFill)
Vue.component('BIconEyeFill', BIconEyeFill)
Vue.component('BIconEyeglasses', BIconEyeglasses)
Vue.component('BIconFileEarmarkCheck', BIconFileEarmarkCheck)
Vue.component('BIconGraphUp', BIconGraphUp)
Vue.component('BIconHouseDoorFill', BIconHouseDoorFill)
Vue.component('BIconHouseFill', BIconHouseFill)
Vue.component('BIconInfoCircleFill', BIconInfoCircleFill)
Vue.component('BIconLink', BIconLink)
Vue.component('BIconPencil', BIconPencil)
Vue.component('BIconPencilFill', BIconPencilFill)
Vue.component('BIconPersonCircle', BIconPersonCircle)
Vue.component('BIconPersonFill', BIconPersonFill)
Vue.component('BIconPersonXFill', BIconPersonXFill)
Vue.component('BIconPlusCircleFill', BIconPlusCircleFill)
Vue.component('BIconLink45deg', BIconLink45deg)
Vue.component('BIconPrinter', BIconPrinter)
Vue.component('BIconQuestionCircleFill', BIconQuestionCircleFill)
Vue.component('BIconTrashFill', BIconTrashFill)
Vue.component('BIconX', BIconX)
Vue.component('BIconXCircle', BIconXCircle)
Vue.component('BIconXCircleFill', BIconXCircleFill)
Vue.component('BIconXLg', BIconXLg)
Vue.component('BIconXSquareFill', BIconXSquareFill)

Utils.registerComponents()
Utils.addCustomMixin('api')
Utils.addCustomMixin('i18n')

let app

Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 540,
        md: 768,
        lg: 1024,
        xl: 1140,
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

app = new Vue({
    router,
    store,
    api,
    i18n,
    render: h => h(App),
}).$mount('#app')

const lang = localStorage.getItem('language')
document.documentElement.lang = lang ?? 'en'
if (lang) {
    document.body.classList.add(lang)
}
if (Capacitor.isNativePlatform()) {
    const setStatusBarStyleDark = async () => {
        await StatusBar.setStyle({ style: Style.Light });
    };
    const setStatusBarColor = async () => {
        await StatusBar.setBackgroundColor({ color: '#ffa725' });
    };
    await setStatusBarStyleDark()
    if (Capacitor.getPlatform() === 'android') {
        await setStatusBarColor()
    }
}

